import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';

const LoginLayout = ({ children }) => {
  const theme = useTheme();
  return <theme.layout.OnboardingLayout>{children}</theme.layout.OnboardingLayout>;
};

LoginLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LoginLayout;
